import { Helmet } from 'react-helmet-async'

const SITE_URL  = 'https://salonvora.com'
const SITE_NAME = 'Salon Vora'
const DEFAULT_DESCRIPTION =
  "Salon Vora is Chennai's premium hair, skin, nails, makeup and wellness studio. Expert stylists, luxury products, hygienic space. Book online."
const DEFAULT_IMAGE = `${SITE_URL}/brand/banner-with-text.png`

/**
 * Page-level SEO component. Wraps react-helmet-async with sensible defaults
 * and supports OG, Twitter, canonical URL, and arbitrary JSON-LD blocks.
 *
 *   <SEO
 *     title="Hair Coloring in Chennai"
 *     description="..."
 *     path="/services/hair-coloring"
 *     image="/brand/services/hair-color.jpg"
 *     jsonLd={[serviceSchema, breadcrumbSchema]}
 *   />
 */
export default function SEO({
  title,
  description = DEFAULT_DESCRIPTION,
  path        = '',
  image       = DEFAULT_IMAGE,
  type        = 'website',
  noIndex     = false,
  jsonLd,
}) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} – Luxury Hair, Skin, Nails & Bridal Studio in Chennai`
  const url       = `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`.replace(/\/+$/, '/')
  const ogImage   = image.startsWith('http') ? image : `${SITE_URL}${image}`

  const blocks = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : []

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:type"        content={type} />
      <meta property="og:site_name"   content={SITE_NAME} />
      <meta property="og:title"       content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image"       content={ogImage} />
      <meta property="og:url"         content={url} />
      <meta property="og:locale"      content="en_IN" />

      {/* Twitter */}
      <meta name="twitter:card"        content="summary_large_image" />
      <meta name="twitter:title"       content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image"       content={ogImage} />

      {blocks.map((block, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(block)}</script>
      ))}
    </Helmet>
  )
}
